import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const TicketListSortType = Object.freeze({
    LAST_NAME_ASC: 'last-name-ascending',
    LAST_NAME_DESC: 'last-name-descending',
    NUMBER_OF_TICKETS_ASC: 'number-of-tickets-ascending',
    NUMBER_OF_TICKETS_DESC: 'number-of-tickets-descending',
    ROLE: 'role',
    PARTICIPANT_GROUP: 'participant-group',
});

export type ITicketListSortType = ValuesType<typeof TicketListSortType>;
